

















































































































































































































































































































































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import { AppModel } from '@/api/model/AppModel';
import ImageUploader from '@/components/common/ImageUploader.vue';
import { API, Storage } from 'aws-amplify';



const appModule = getModule(Apps);

@Component({
    components: {
        CardTitle,
        DescriptionEditor,
        ImageUploader
    },
})
export default class AppsAddRenameDialog extends Vue {
    private open = false;
    private internalValue = '';
    private internalDescription = '';
    private internalLogo = '';
    private internalIcon = '';
    private internalHomepage = '';
    private internalSubscriptionStatus = false;
    private internalImageMain = '';
    private internalImageMainUrl = null;
    private internalTags = [];
    private internalRating = 0;
    private internalCta = '';
    private internalPreviewUrl = '';
    private internalShowHomepage = false;
    private internalTileViewImg = '';
    private internalUserPermission = '';
    private internalHero = false;

    private iconUrl = '';
    private logoUrl = '';
    private tileUrl = '';
    private mainUrl = '';

    private roles = 
    [
        {
            value: '1',
            text: 'Admin'
        },
        {
            value: '2',
            text: 'Editor',
        },
        {
            value: '3',
            text: 'User',
        }
    ]

    @Prop({ default: false, type: Boolean})
    mainApp!: boolean;

    @Prop({ default: '', type: String })
    decisionId!: string;

    @Prop({default: "", type: String})
    appId!: string;

    @Prop()
    show!: boolean;

    @Prop({ default: false, type: Boolean })
    isRename!: boolean;

    @Model('updated:text')
    value!: string;

    @Model('updated:text')
    description!: string;

    @Model('updated:text')
    logo!: string;

    @Model('updated:text')
    icon!: string;

    get appDictionary(){
        return appModule.appsDictionary;
    }

    get selectedApp(){
        if(this.appDictionary && this.appId){
            return this.appDictionary[this.appId];
        }else{
            return {};
        }
    }

    mounted() {
        this.internalValue = this.appDictionary[this.appId]?.name;
        this.internalDescription = this.appDictionary[this.appId]?.description;
        this.internalLogo = this.appDictionary[this.appId]?.logo;
        this.internalIcon = this.appDictionary[this.appId]?.icon;
        this.internalHomepage = this.appDictionary[this.appId]?.homepage
        this.internalSubscriptionStatus = this.appDictionary[this.appId]?.subscriptionStatus;
        this.internalImageMain = this.appDictionary[this.appId]?.imageMain;
        this.internalTags = this.appDictionary[this.appId]?.tags;
        this.internalRating = this.appDictionary[this.appId]?.rating;
        this.internalCta = this.appDictionary[this.appId]?.cta;
        this.internalPreviewUrl = this.appDictionary[this.appId]?.previewUrl;      
        this.internalShowHomepage = this.appDictionary[this.appId]?.showHomepage;   
        this.internalTileViewImg = this.appDictionary[this.appId]?.tileViewImage;
        this.internalUserPermission = this.appDictionary[this.appId]?.userPermission;
        this.internalHero = this.appDictionary[this.appId]?.hero;
        // this.getImage();
        if (this.show) {
            setTimeout(() => (this.open = this.show), 200);
        }

    }

    // Probably need in future
    private async getImage() {
        if (this.internalIcon) {
            let iconRes = await Storage.get(this.internalIcon);
            this.iconUrl = iconRes.toString();
        };
        if (this.internalLogo) {
            let logoRes = await Storage.get(this.internalLogo);
            this.logoUrl = logoRes.toString();
        }
        if (this.internalTileViewImg) {
            let tileRes = await Storage.get(this.internalTileViewImg);
            this.tileUrl = tileRes.toString();
        }
        if (this.internalImageMain) {
            let imgMainRes = await Storage.get(this.internalImageMain);
            this.mainUrl = imgMainRes.toString();
        }
    }

    private updateChildUrl( url: string ) {
        const param = 'vptime=';
        // Remove & from end of string if it exists
        if (url.substring(url.length - 1) == '&') {
            url = url.substring(0, url.length - 1);
        }
        
        if (!url.includes(param)) {
            return url + '&' + param + this.internalUserPermission;
        } else {
            let link = url.split(param);
            return link[0] + param + this.internalUserPermission + link[1].substring(1);
        }
    }

    private updateChildren( children ) {
        if ( children.length > 0 ) {
            return children.map((child) => {
                return {
                    ...child,
                    href: this.updateChildUrl( child.href ),
                    children: this.updateChildren( child.children )
                }
            });
        } else {
            return children;
        }
    }

    @Watch('internalImageMain')
    async onInternalImageMainChange(newKey: string) {
        console.log('new key')
        console.log(newKey)
        this.internalImageMainUrl = await Storage.get(newKey);
    }

    @Watch('open')
    onOpenChange(newVal: boolean, oldVal: boolean) {
        if (!newVal && oldVal) {
            this.closedMenu();
        } else if (newVal) {
            this.internalValue = this.appDictionary[this.appId]?.name;
            this.internalDescription = this.appDictionary[this.appId]?.description;
            this.internalLogo = this.appDictionary[this.appId]?.logo;
            this.internalIcon = this.appDictionary[this.appId]?.icon;
            this.internalHomepage = this.appDictionary[this.appId]?.homepage
            this.internalSubscriptionStatus = this.appDictionary[this.appId]?.subscriptionStatus;
            this.internalImageMain = this.appDictionary[this.appId]?.imageMain;
            this.internalTags = this.appDictionary[this.appId]?.tags;
            this.internalRating = this.appDictionary[this.appId]?.rating;
            this.internalCta = this.appDictionary[this.appId]?.cta;
            this.internalPreviewUrl = this.appDictionary[this.appId]?.previewUrl;
            this.internalShowHomepage =  this.appDictionary[this.appId]?.showHomepage;
            this.internalTileViewImg = this.appDictionary[this.appId]?.tileViewImage;
            this.internalUserPermission = this.appDictionary[this.appId]?.userPermission;
            this.internalHero = this.appDictionary[this.appId]?.hero;
            this.$emit('open');
        }
    }

    @Emit('closed')
    @Emit('save')
    @Emit('updated:text')
    private async save() {
        // await this.checkPictureForSubmit();
        if (this.isRename) {
            this.selectedApp.children = this.updateChildren(this.selectedApp.children);
            this.selectedApp.name = this.internalValue;
            this.selectedApp.description = this.internalDescription;
            this.selectedApp.icon = this.internalIcon;
            this.selectedApp.logo = this.internalLogo;
            this.selectedApp.homepage = this.internalHomepage;
            this.selectedApp.subscriptionStatus = this.internalSubscriptionStatus;
            this.selectedApp.imageMain = this.internalImageMain;
            this.selectedApp.tags = this.internalTags;
            this.selectedApp.rating = this.internalRating;
            this.selectedApp.cta = this.internalCta;
            this.selectedApp.previewUrl = this.internalPreviewUrl;
            this.selectedApp.showHomepage = this.internalShowHomepage;
            this.selectedApp.tileViewImage = this.internalTileViewImg;
            this.selectedApp.userPermission = this.internalUserPermission;
            this.selectedApp.hero = this.internalHero;
            const param = {
                decisionId: this.decisionId,
                appId: this.selectedApp.id,
                app: this.selectedApp
            }
            await appModule.updateApps(param).then((res) => {
                this.open = false;
            });
        } else {
            const newApp: AppModel = {
                id: '',
                name: this.internalValue,
                description: this.internalDescription,
                icon: this.internalIcon,
                children: [],
                logo: this.internalLogo,
                homepage: this.internalHomepage,
                subscriptionStatus: false,
                imageMain: this.internalImageMain,
                tags: this.internalTags,
                rating: this.internalRating,
                cta: this.internalCta ,
                previewUrl: this.internalPreviewUrl,
                showHomepage: this.internalShowHomepage,
                tileViewImage: this.internalTileViewImg,
                userPermission: this.internalUserPermission,
                hero: this.internalHero,
            };
            const param = {
                decisionId: this.decisionId,
                app: newApp,
            };
            await appModule.createApp(param).then((res) => {
                this.open = false;
            });
        }
    }

    @Emit('cancel')
    private cancel() {
        // this.checkPictureForCancel();
        this.internalValue = this.value;
        this.open = false;
    }

    @Emit('change')
    @Emit('updated:text')
    private updateValue(newValue: string) {
        this.open = false;
        return newValue;
    }

    @Emit('closed')
    private closedMenu() {
        return this.internalValue;
    }
    

    private clear() {
        this.internalValue = "";
    }

     private async checkPictureForSubmit(){
        try {
            // check if the image key has been changed. and if the old key exists If it has remove the old file
            if(this.appDictionary[this.appId]?.tileViewImage !== this.internalTileViewImg && this.appDictionary[this.appId]?.tileViewImage){
               await Storage.remove(this.appDictionary[this.appId]?.tileViewImage);
            }
            if(this.appDictionary[this.appId]?.imageMain !== this.internalImageMain && this.appDictionary[this.appId]?.imageMain){
               await Storage.remove(this.appDictionary[this.appId]?.imageMain);
            }
            if(this.appDictionary[this.appId]?.icon !== this.internalIcon && this.appDictionary[this.appId]?.icon){
               await Storage.remove(this.appDictionary[this.appId]?.icon);
            }
            if(this.appDictionary[this.appId]?.logo !== this.internalLogo && this.appDictionary[this.appId]?.logo){
               await Storage.remove(this.appDictionary[this.appId]?.logo);
            }
        } catch (error) {
            console.log(error);
        }
    }

    private async checkPictureForCancel(){
        try {
             // check if the image key has been changed and if there is new key. 
            // new key means user just uploaded a new image, which means that new image needs to be deleted
            if(this.appDictionary[this.appId]?.tileViewImage !== this.internalTileViewImg && this.internalTileViewImg ){
                await Storage.remove(this.internalTileViewImg)
            }
            if(this.appDictionary[this.appId]?.imageMain !== this.internalImageMain && this.internalImageMain ){
                await Storage.remove(this.internalImageMain)
            }
            if(this.appDictionary[this.appId]?.icon !== this.internalIcon && this.internalIcon ){
                await Storage.remove(this.internalIcon)
            }
            if(this.appDictionary[this.appId]?.logo !== this.internalLogo && this.internalLogo ){
                await Storage.remove(this.internalLogo)
            }
        } catch (error) {}
    }

}
